var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import AddressModel from "./AddressModel";
import BaseModel from "./BaseModel";
var DeliveryDetails = /** @class */ (function (_super) {
    __extends(DeliveryDetails, _super);
    function DeliveryDetails(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.address = hydrated.address;
        _this.destinationId = hydrated.destinationId;
        _this.notes = hydrated.notes;
        _this.phone = hydrated.phone;
        _this.price = hydrated.price;
        _this.taxableDeliveryFee = hydrated.taxableDeliveryFee;
        return _this;
    }
    DeliveryDetails.prototype.hydrate = function (data) {
        var hydrated = {};
        hydrated.address = new AddressModel({
            address_id: data.address_id || null,
            base: data.base || null,
            cr_date: data.cr_date || null,
            formatted_address: data.address || null,
            apt_num: data.apt_num || null,
            name: data.customer_name || null,
            lat: data.lat || null,
            lng: data.lng || null
        });
        hydrated.destinationId = data.destination_id;
        hydrated.notes = data.notes;
        hydrated.phone = data.phone;
        hydrated.price = data.price;
        hydrated.taxableDeliveryFee = data.taxable_delivery_fee;
        return hydrated;
    };
    DeliveryDetails.prototype.getFormattedAddress = function () {
        var address = this.address;
        if (address && address.formattedAddress) {
            return address.formattedAddress;
        }
        return false;
    };
    return DeliveryDetails;
}(BaseModel));
export default DeliveryDetails;



//////////////////
// WEBPACK FOOTER
// ./src/models/DeliveryDetails.ts
// module id = Xy25
// module chunks = 18